import { ForwardedRef, forwardRef, memo } from 'react'
import classNames from 'classnames'

import css from './CarouselControls.module.scss'

import Label from '@/components/Label/Label'

export type CarouselControlsHandle = {
  //
}

export interface CarouselControlsProps {
  className?: string
  handleRef?: ForwardedRef<CarouselControlsHandle>
  backCallback?: () => void
  forwardCallback?: () => void
}

export interface ViewProps extends CarouselControlsProps {}

// View (pure and testable component, receives props from the controller)
export const View = forwardRef<HTMLDivElement, ViewProps>(({ className, backCallback, forwardCallback }, ref) => {
  return (
    <div className={classNames('CarouselControls', css.root, className)} ref={ref}>
      <button className={css.controlButton} onClick={backCallback}>
        <Label labelType={3}>PREV</Label>
      </button>
      <Label labelType={3}>&nbsp;&nbsp;/&nbsp;&nbsp;</Label>
      <button className={css.controlButton} onClick={forwardCallback}>
        <Label labelType={3}>NEXT</Label>
      </button>
    </div>
  )
})

View.displayName = 'CarouselControls-View'

// Controller (handles global state, router, data fetching, etc. Feeds props to the view component)
const CarouselControls = forwardRef<HTMLDivElement, CarouselControlsProps>((props, ref) => {
  return <View {...props} ref={ref} />
})

CarouselControls.displayName = 'CarouselControls'

export default memo(CarouselControls)
